import { render, staticRenderFns } from "./propertyView.vue?vue&type=template&id=85ad79f4&scoped=true&"
import script from "./propertyView.vue?vue&type=script&lang=js&"
export * from "./propertyView.vue?vue&type=script&lang=js&"
import style0 from "./propertyView.vue?vue&type=style&index=0&id=85ad79f4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ad79f4",
  null
  
)

export default component.exports